/**
 * @generated SignedSource<<3a19562e4e2c8872b39532c73f49ee98>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type WebPushSubscriptionInput = {
  auth: string;
  endpoint: string;
  p256Dh: string;
};
export type subscribeClientMutation$variables = {
  input: WebPushSubscriptionInput;
};
export type subscribeClientMutation$data = {
  readonly subscribeClient: boolean | null | undefined;
};
export type subscribeClientMutation = {
  response: subscribeClientMutation$data;
  variables: subscribeClientMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "kind": "ScalarField",
    "name": "subscribeClient",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "subscribeClientMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "subscribeClientMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "50db81c00cbe24067ca055da45d276b3",
    "id": null,
    "metadata": {},
    "name": "subscribeClientMutation",
    "operationKind": "mutation",
    "text": "mutation subscribeClientMutation(\n  $input: WebPushSubscriptionInput!\n) {\n  subscribeClient(input: $input)\n}\n"
  }
};
})();

(node as any).hash = "5ec051e15a375c4f15e59c4da05548df";

export default node;
